<script>
    export default {
        props: ['companyprop'],
        data() {
            return {
                company: null
            }
        },
        computed: {
        },
        watch: {

        },
        created() {
            this.company = this.companyprop
        },
        mounted() {
            //this.company = this.companyprop
        },
        methods: {

        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/seo/SeoCompanyCardContainer.vue